import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBolt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" })
});
export default SvgBolt;
